// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BigSaleModal_wrapper__XgZLa"};